var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{chrome:_vm.isActive},attrs:{"id":"app"}},[_c('router-view',{class:_vm.$route.name})],1)}
var staticRenderFns = []

export { render, staticRenderFns }